// Height of the sand across the beach: flat at the promenade (z = 51), then sloping under the water past z = 61.
import { MathUtils } from 'three';

export function beachSlope(z) {
  const t = MathUtils.clamp((z - 51) / 14, 0, 1);
  return 0.3 - t * 0.3 - Math.max(0, t - 0.72) * 2.2;
}
